import React, { FC } from "react";
import { Tooltip } from "@shared/components";
import "./index.scss";

export interface TitleBlockProps {
  status: string;
}

const statuses: Record<
  string,
  {
    color?: string;
    text?: string;
    tooltip?: string;
  }
> = {
  active: {
    color: "green",
    text: "Active",
    tooltip: "The subscription is currently running and up to date with all billing.",
  },
  paused: {
    color: "red",
    text: "Paused",
    tooltip: "The subscription is temporarily suspended; billing is on hold until it's resumed.",
  },
  past_due: {
    color: "red",
    text: "Missed Payment",
    tooltip:
      "The subscription has missed a payment and is in a delinquent state, requiring action to continue service.",
  },
  non_renewing: {
    color: "yellow",
    text: "Expiring",
    tooltip:
      "The subscription will expire at the end of the current term, as the customer has opted not to renew automatically.",
  },
  canceled: {
    text: "Cancelled",
    tooltip: "The subscription was terminated and no further billing or renewals will occur.",
  },
  cancelled: {
    text: "Cancelled",
    tooltip: "The subscription was terminated and no further billing or renewals will occur.",
  },
  incomplete_expired: {
    text: "Expired",
    tooltip:
      "The subscription was not successfully activated within the payment timeframe, resulting in an expired state without completion.",
  },
};

const SubscriptionsStatus: FC<TitleBlockProps> = ({ status }) => (
  <Tooltip position="bottom" content={statuses[status]?.tooltip || null}>
    <div className={`subscription-status ${statuses[status]?.color || "gray"}`}>
      {statuses[status]?.text || "Inactive"}
    </div>
  </Tooltip>
);

export default SubscriptionsStatus;
